import React from 'react';
import styled from 'styled-components';
import {
  SectionWrapper,
  HeadlineOne,
  Paragraph,
  HeadlineTwo,
} from 'components/atoms/SectionWrapper.style';
import ButtonContact from 'components/atoms/button/ButtonContact';

const First = styled.div`
  /* height: 350px; */
  /* margin-top: 100px; */
  text-align: justify;
  width: 95%;
  margin: 80px auto;
  padding: 15px;

  @media ${({ theme }) => theme.media.tablet} {
    width: 85%;
    padding: 30px;
    border: dashed 4px #218921;
  }
`;

const EleSlider = () => (
  <>
    <First>
      <HeadlineOne>O NAS</HeadlineOne>
      {/* <Paragraph>
        Energia ze słońca to darmowy prąd dla każdego.
        <br /> Skontaktuj się z nami!
      </Paragraph> */}

      <Paragraph>
        Firma ELGREEN EM Eeltromobulity powstała w 2022 roku z myślą przewodnią
        rozwoju infrastruktury stacji ładowania w Polsce. Na bazie wieloletniego
        doświadczenia na rynku energetycznym w Polsce oraz chęci wdrażania
        innowacyjnych rozwiązań na rynek, a także proekologicznego podejścia do
        otoczenia podjęliśmy decyzję o budowie nowego działu w naszej firmie.
      </Paragraph>
      <Paragraph>
        Samochody Elektryczne stają się rzeczywistością na Polskich drogach, ich
        ilość systematycznie rośnie a w parze z przyrostem użytkowników aut
        elektrycznych konieczny jest ciągły rozwój infrastruktury. Stąd też w
        krótkim czasie dostarczyliśmy rozwiązania dla naszych kontrahentów
        między innym zaufali nam: BMW Bawaria Motors Gdańsk i Katowice; Makro
        Polska Al. Jerozolimskie, Bielany Przejazdowo, Galeria Sopot oraz wielu
        klientów indywidualnych.
      </Paragraph>
      <Paragraph>
        Nasza Firma posiada pełne zaplecze inżynieryjne i wykonawcze oraz jest
        wpisana w listę kwalifikowanych wykonawców w Energa Operator co w
        połączeniu daje kompendium możliwości związanych z analizą,
        przygotowaniem projektowym, realizacją i obsługą serwisową.
      </Paragraph>

      <Paragraph>
        We współpracy z Klientami biznesowymi jak i indywidualnymi, stawiamy
        przede wszystkim na rzetelność i profesjonalizm w tym celu korzystamy
        wyłącznie ze sprawdzonych partnerów, materiałów i technologii, które
        zestawiając z naszym doświadczeniem przekładają się na kompletny i
        gotowy produkt inwestycyjny.
      </Paragraph>
      <Paragraph>Zapraszamy do zapoznania się z naszą ofertą</Paragraph>

      {/* <ButtonContact /> */}
    </First>
  </>
);

export default EleSlider;
